import './Search.scss';
import React from 'react';
import { generalStore } from '../../store';

export const Search = () => {
    const { setIsSearchBarOpen, isSearchBarOpen } = generalStore();

    const toggleOpen = () => {
        const nextValue = !isSearchBarOpen;
        setIsSearchBarOpen(nextValue);
    };

    return (
           <div className="b-search">
                <div onClick={toggleOpen} className="search-icon" data-testid="global-search-button" />
            </div>
    )
}

export default Search;
